import { Anchor, Card, Center, Code, Stack, Text, Title } from '@mantine/core';
import { IconTicket } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { generatedCouponLabels } from '../../helpers/platformLabel';
import LockableButton from '../Lockable/LockableButton';

const GeneratedCouponsEmptyState = ({ onCreateGeneratedCoupon, onUploadCoupons }) => {
  const platform = useSelector((state) => state.domain.domain?.platform);
  const labels = generatedCouponLabels(platform);
  return (
    <Card withBorder>
      <Center py={80}>
        <Stack align="center" gap="md" maw={480} ta="center">
          <IconTicket size={48} stroke={1} color="var(--mantine-color-dimmed)" />
          <Title order={4}>No coupons yet</Title>
          <Text c="dimmed">
            Generate unique one-time codes in {labels.store} and use them with{' '}
            <Code>{'{{dynamicCoupons.<name>}}'}</Code> in any channel.
          </Text>
          <LockableButton restrictionKey="couponsCreate" onClick={onCreateGeneratedCoupon}>
            {labels.create}
          </LockableButton>
          <Anchor component="button" type="button" size="sm" onClick={onUploadCoupons}>
            or upload a list of codes
          </Anchor>
        </Stack>
      </Center>
    </Card>
  );
};

export default GeneratedCouponsEmptyState;
